module.exports = __webpack_public_path__ + "static/media/logo-maratona-intensiva.c1a18f2a.png";